export function isValidPhoneNumberFormat(phoneNumber) {
    const phoneRegex = /^\+?([\s()-]*\d[\s()-]*){10,13}$/;
    return phoneRegex.test(phoneNumber);
}